import { useDispatch } from "react-redux";
import CustomToast from "../../toastify/CustomToast";
import { useEffect, useState } from "react";
import { GET_TERMS_CONDITION } from "../../redux/actions/CommonActions";
import Parser from "html-react-parser";
import '../termPolicy/TermsCss.css';
import logo from "../../assets/images/logo.svg";

const TermsOfUse = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState('');

  const getData = async () => {
    dispatch(GET_TERMS_CONDITION())
      .then((res) => {
        console.log(res);
        setData(res[0]);
      })
      .catch((e) => {
        CustomToast.error(e);
        console.log(e);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div style={{ marginTop: 20 }} className="text-center">
      {/* Logo Section */}
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo-img" />
      </div>

      {/* Title */}
      <p style={{ fontSize: 20, fontWeight: 700, color: "black" }}>
        {data?.title}
      </p>

      {/* HTML Content */}
      <div className="html-wrapper">
        {typeof data?.description === 'string' ? Parser(data.description) : <p>Loading...</p>}
      </div>
    </div>
  );
};

export default TermsOfUse;
